<template>
    <div class="login">
        <div class="box">
            <div class="img">
                <img src="@/assets/logoo.png" alt />
            </div>
            <div class="username">
                <span>
                    <i class="iconfont iconwode"></i>
                </span>
                <!-- <div class="line"></div> -->
                <input type="text" autocapitalize="off" v-model="$v.param.username.$model" maxlength="16" placeholder="用户名" @blur="resetH" @input="param.username = param.username.replace(/\s+/g,'')" />
            </div>
            <div class="password">
                <span>
                    <i class="iconfont iconmima"></i>
                </span>
                <!-- <div class="line"></div> -->
                <input v-model="$v.param.password.$model" type="password" pattern="[0-9]*" placeholder="密码" @blur="resetH" oninput="if(value.length>16)value=value.slice(0,16)" @input="param.password = param.password.replace(/\s+/g,'')" />
            </div>
            <div class="drag">
                <slider @slide="isSlide" />
            </div>
            <div class="loginBtn" :loading="!canClick" @click="signIn">登&emsp;&emsp;录</div>
        </div>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
// import { regex } from 'vuelidate/lib/validators/common';
import slider from "@/components/slider";
import { removeToken, removeUser } from "@//utils/auth";
import { requestQiniuToken } from "@/api";
import { mapState } from "vuex";
import request from "@/utils/request";
//import {setBindStatus,setUserInfo} from 'vuex'
// const phone = regex('phoneNumber', /^1[3-9]\d{9}$/); //手机号码校验
export default {
    name: "login",
    data() {
        return {
            param: {
                username: "",
                password: ""
            },
            text: "按住左边滑块，拖动完成上方拼图",
            confirmSuccess: false,
            canClick: true
        };
    },
    components: { slider },
    validations: {
        param: {
            username: {
                required
            },
            password: {
                required
            }
        }
    },
    computed: {
        ...mapState(["upload_qiniu_addr"])
    },
    created() {
        removeToken();
        removeUser();
    },
    mounted() {
        let param = { phone: "17626047262", source: "crm" };
        this.$store
            .dispatch("getToken", param)
            .then(res => {
                this.getQiniuToken();
            })
            .catch(err => {});
    },
    methods: {
        isSlide(data) {
            this.confirmSuccess = data;
        },
        //登陆
        signIn() {
            if (!this.$v.param.username.required) {
                this.$toast.fail("工牌号不能为空", "fail");
                return;
            }
            if (!this.$v.param.password.required) {
                this.$toast.fail("密码不能为空", "fail");
                return;
            }
            if (!this.confirmSuccess) {
                this.$toast.fail("请拖动完成验证", "fail");
                return;
            }
            this.canClick = false;
            this.$store
                .dispatch("getToken", this.param)
                .then(() => {
                    this.$toast.success({
                        message: "登录成功",
                        forbidClick: true,
                        onClose: () => {
                            this.$router.push({ path: "/" });
                            this.canClick = false;
                        }
                    });
                })
                .catch(() => {
                    this.canClick = false;
                });
        },
        resetH() {
            window.scroll(document.body.scrollTop, 0);
        }
    },
    watch: {
        //'param.phone': function (newVal, oldVal) {
        //if (this.param.phone && this.param.code) {
        //this.canClick = true;
        //} else {
        //this.canClick = false;
        //}
        //},
        //'param.code': function (newVal, oldVal) {
        //if (this.param.phone && this.param.code) {
        //this.canClick = true;
        //} else {
        //this.canClick = false;
        //}
        //}
    }
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.login {
    font-size: 0.4rem;
    position: fixed;
    background-color: #fff;
    // margin-top: 3rem;
    width: 100%;
    height: 100%;
    .head {
        height: 1px;
    }
    .box {
        border: none;
        margin: 0;
        padding: 1rem 1rem 0;
        margin: 0 auto;
        .img {
            text-align: center;
            border: none;
            margin-bottom: 1rem;
            img {
                width: 7rem;
            }
        }
        > div {
            // width: 8rem;
            line-height: 1.2rem;
            padding: 0 0.4rem;
            border: 1px solid $border-color;
            // border-radius: 0.2rem;
            background-color: #fff;
            text-align: left;
            overflow: hidden;
            position: relative;
            color: $border-color;
            .line {
                position: absolute;
                height: 33%;
                left: 40px;
                top: calc(50% - 0.2rem);
                width: 1px;
                background: #a0a0a0;
                transform: translateY(-50%);
            }
            .iconfont {
                font-size: 0.5rem;
            }
            input {
                outline: none;
                border: none;
                margin-left: 0.4rem;
                font-size: 0.4rem;
                line-height: 0.6rem;
                height: 0.6rem;
                color: #323232;
            }
        }
        .username {
            border-bottom: none;
            // border-radius: 0.2rem 0.2rem 0 0;
        }
        .password {
            // border-radius: 0 0 0.2rem 0.2rem;
        }
        .drag {
            padding: 0;
            border-top: none;
        }
        .loginBtn {
            color: #fff;
            background-color: #fd7e2d;
            border: none;
            // padding: 0.2rem 1rem;
            text-align: center;
            width: 8rem;
            border-radius: 0.2rem;
            margin-top: 0.5rem;
            // height: 1rem;
        }
        .canClick {
            background-color: #888888;
            opacity: 0.5;
            pointer-events: none;
        }
    }
    .slide {
        position: fixed;
        z-index: 10;
        top: 10%;
        left: 50%;
        transform: translateX(-50%);
        background-color: #fff;
        width: 90%;
        border-radius: 0.5rem;
        .close {
            text-align: right;
            padding: 0.2rem 0.3rem;
            i {
                font-size: 0.5rem;
                color: #7a7a7a;
            }
        }
        #slideVerify {
            padding: 0;
            margin: 0 auto;
            font-size: 0.3rem;
        }
        .tips {
            padding: 0.5rem 0;
            font-size: 0.4rem;
            color: #616060;
        }
    }
    .model {
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 5;
        background: #000;
        opacity: 0.5;
        top: 0;
        left: 0;
    }
    ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: $border-color;
    }

    ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: $border-color;
    }

    :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: $border-color;
    }
}
.upload {
    width: 2.133rem;
    height: 2.133rem;
    video {
        width: 100%;
        height: 100%;
    }
}
</style>
